/**
 * Server-Sent Events (SSE) parsing utilities
 *
 * Shared utilities for parsing SSE streams from the backend.
 */

import type { StreamingEvent } from '../api/types';
import { createLogger } from '../utils/logger';

const logger = createLogger('SSE');

/**
 * Parse a single SSE event from a text line
 *
 * Exported for testing and reuse across different streaming hooks.
 */
export function parseSSEEvent(
  eventType: string,
  data: string,
): StreamingEvent | null {
  try {
    const parsed: unknown = JSON.parse(data);
    if (typeof parsed !== 'object' || parsed === null) return null;
    const event = parsed as Record<string, unknown>;
    // Add event type if not present in data
    if (!event.event) {
      event.event = eventType;
    }
    return event as unknown as StreamingEvent;
  } catch (e) {
    logger.error('Failed to parse event', { eventType, data, error: e });
    return null;
  }
}
